import ProductWaffle from './ProductWaffle';

export default ProductWaffle;
